import { Dealer } from './dealer.model';

export class DealerResponse {
  dealerList: Dealer[];
  total: number;

  constructor(dealerList: any, total: any) {
    this.dealerList = dealerList;
    this.total = total;
  }
}
